import { debounce } from "lodash";
import { useCallback, useEffect, useState } from "react";

const useDebounce = ({ toDebounce }) => {
  const [debounced, setDebounced] = useState(toDebounce);
  // const [debounceCount, setDebounceCount] = useState(0);

  const updateDebounced = useCallback(
    debounce((newToDebounce) => {
      setDebounced(newToDebounce);
    }, 600),
    []
  );

  useEffect(() => {
    // setDebounceCount((prevCount) => prevCount + 1);
    updateDebounced(toDebounce);
  }, [toDebounce, updateDebounced]);

  return {
    debounced,
    // debounceCount
  };
};

export default useDebounce;
